import React, { useState } from "react";

const InviteUserFormTab = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    email: '',
    firstName: '',
    lastName: '',
    temporaryPassword: '',
    role: 'student'
  });
  const [submitting, setSubmitting] = useState(false);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const result = await onSubmit(formData);
      if (result?.success) {
        setFormData({
          email: '',
          firstName: '',
          lastName: '',
          temporaryPassword: '',
          role: 'student'
        });
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div className="d-flex items-center mb-20">
        <div className="size-40 d-flex justify-center items-center bg-purple-3 rounded-full mr-15">
          <i className="text-16 icon-user-plus text-purple-1"></i>
        </div>
        <h5 className="text-18 lh-1 fw-500">Invite New User</h5>
      </div>
      
      <form onSubmit={handleSubmit} className="contact-form respondForm__form row y-gap-20">
        <div className="col-12">
          <label className="text-13 fw-500 text-dark-1 mb-10">Email Address *</label>
          <input 
            type="email" 
            name="email" 
            value={formData.email}
            onChange={handleInputChange}
            placeholder="user@example.com"
            className="form-control"
            required
          />
        </div>
        
        <div className="col-md-6">
          <label className="text-13 fw-500 text-dark-1 mb-10">First Name *</label>
          <input 
            type="text" 
            name="firstName" 
            value={formData.firstName}
            onChange={handleInputChange}
            placeholder="John"
            className="form-control"
            required
          />
        </div>
        
        <div className="col-md-6">
          <label className="text-13 fw-500 text-dark-1 mb-10">Last Name *</label>
          <input 
            type="text" 
            name="lastName" 
            value={formData.lastName}
            onChange={handleInputChange}
            placeholder="Doe"
            className="form-control"
            required
          />
        </div>
        
        <div className="col-12">
          <label className="text-13 fw-500 text-dark-1 mb-10">Temporary Password *</label>
          <div className="form-password">
            <input 
              type="password" 
              name="temporaryPassword" 
              value={formData.temporaryPassword}
              onChange={handleInputChange}
              placeholder="Min. 6 characters"
              className="form-control"
              minLength="6"
              required
            />
            <div className="form-password__button">
              <button type="button" className="js-password-button">
                <i className="icon icon-eye"></i>
              </button>
            </div>
          </div>
          <div className="text-11 text-light-1 mt-5">
            Password will be sent via email. User must change on first login.
          </div>
        </div>
        
        <div className="col-12">
          <label className="text-13 fw-500 text-dark-1 mb-10">Role</label>
          <select 
            name="role" 
            value={formData.role}
            onChange={handleInputChange}
            className="form-control"
          >
            <option value="student">Student</option>
            <option value="instructor">Instructor</option>
            <option value="admin">Admin</option>
          </select>
        </div>
        
        <div className="col-12 pt-10">
          <button 
            type="submit" 
            disabled={submitting}
            className="button -md bg-purple-1 text-white fw-500 w-1/1"
          >
            {submitting ? (
              <>
                <i className="icon-spinner mr-10"></i>
                Sending...
              </>
            ) : (
              <>
                <i className="icon-mail mr-10"></i>
                Send Invitation
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default InviteUserFormTab; 